import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import { useDeleteDocumentsAsset } from "../Orion/OrionQueries";
import { DialogProps } from "./useDialogs";

function DeleteAssetDocumentDialog({
  payload,
  open,
  onClose,
}: DialogProps<{ id: string; name: string | null; assetId: string }>) {
  const { mutate: deleteDocuments } = useDeleteDocumentsAsset();

  return (
    <Dialog
      open={open}
      onClose={() => onClose()}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <DialogTitle id="alert-dialog-title">
        {`Supprimer ${payload.name}?`}
      </DialogTitle>
      <DialogContent>
        <DialogContentText id="alert-dialog-description">
          {`Vous êtes sur le point de supprimer un document ${payload.name ? `(${payload.name}) ` : ""}du dossier`}
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={() => onClose()}>Annuler</Button>
        <Button
          onClick={() => {
            deleteDocuments({
              assetId: payload.assetId,
              documents: [payload.id],
            });
            onClose();
          }}
          autoFocus
        >
          Supprimer
        </Button>
      </DialogActions>
    </Dialog>
  );
}

export default DeleteAssetDocumentDialog;
